import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import AssignRequirements from "../../../pages/requirements/AssignRequirements";
import AssignFreelancers from "../../../pages/requirements/AssignFreelancers";
import FreeLancers from "../../../pages/users/freelancers/FreeLancers";
import FreelancerInfo from "../../../pages/users/freelancers/FreelancerInfo";
import FreelancerReport from "../../../pages/users/freelancers/FreelancerReport";

import Users from "../../../pages/users";
import Projects from "../../../pages/projects";
import Chat from "../../../pages/chat";
import Plans from "../../../pages/plans";

import AdminCandidates from "../../../pages/admin/Candidates";
import AssignedCandidates from "../../../pages/admin/AssignedCandidates";
import Share from "../../../pages/admin/Share";
import Activity from "../../../pages/activity/Activity";
import FreeMessageActivity from "../../../pages/activity/FreeMsgActivity";
import CandidateActivity from "../../../pages/activity/CandidateActivity";
import AdminInvoiceHistory from "../../../pages/admin/AdminInvoiceHistory";

import AllSTC from "../../../pages/admin/reports/Stc";
import AllScheduleInterview from "../../../pages/admin/reports/ScheduleInterview";
import AllDocumentColleted from "../../../pages/admin/reports/DocumentColleted";
import AllFinalInterviewCompleted from "../../../pages/admin/reports/FinalInterviewCompleted";
import AllJoined from "../../../pages/admin/reports/Joined";
import AllOffered from "../../../pages/admin/reports/Offered";
import AllOfferedDeclined from "../../../pages/admin/reports/OfferedDeclined";
import AllSalaryBreakup from "../../../pages/admin/reports/SalaryBreakup";
import AllInvoiced from "../../../pages/admin/reports/Invoiced";
import AllDitched from "../../../pages/admin/reports/Ditched";
import AllCreditNotes from "../../../pages/admin/reports/CreditNotes";
import AllDrop from "../../../pages/admin/reports/Drop";

import New from "../../../pages/admin/dashboard/New";
import STC from "../../../pages/admin/dashboard/Stc";
import DocumentColleted from "../../../pages/admin/dashboard/DocumentColleted";
import FinalInterviewCompleted from "../../../pages/admin/dashboard/FinalInterviewCompleted";
import FinalInterviewScheduled from "../../../pages/admin/dashboard/FinalInterviewScheduled";
import InterviewScheduled from "../../../pages/admin/dashboard/InterviewScheduled";
import ScheduleInterview from "../../../pages/admin/dashboard/ScheduleInterview";
import Joined from "../../../pages/admin/dashboard/Joined";
import Offered from "../../../pages/admin/dashboard/Offered";
import SalaryBreakup from "../../../pages/admin/dashboard/SalaryBreakup";
import YetToJoin from "../../../pages/admin/dashboard/YetToJoin";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import Source from "../../../pages/source/Source";
import Department from "../../../pages/source/Department";
import ParsedResume from "../../Candidates/ParsedResume";
import Requirements from "../../../pages/requirements/Requirements";
import Singlechat from "../../../pages/chat/Singlechat";

import Transaction from "../../../pages/transaction";
import Ticket from "../../../pages/ticket";

import Clients from "../../../pages/clients";
import ResumeSearch from "../../../pages/resumeSearch/ResumeSearch";
import { jwtDecode } from "jwt-decode";
import PageNotFound from "../../page_not_found/PageNotFound";
import Vendors from "../../../pages/users/vendor/Vendors";
import VendorInfo from "../../../pages/users/vendor/VendorInfo";
import VendorReport from "../../../pages/users/vendor/VendorReport";
import AssignVendors from "../../../pages/requirements/AssignVendors";
import VendorInvoiceHistory from "../../../pages/admin/VendorInvoiceHistory";
import Employers from "../../../pages/users/Employers";

import EmployeeLeave from "../../../pages/employee/attendance/leave/EmployeeLeave";
import EmployeePermission from "../../../pages/employee/attendance/permission/EmployeePermission";

import AddProjectDetails from "../../../pages/employee/projectDetails/AddProjectDetails";
import AdminCalendarUI from "../../../pages/employee/calender/AdminCalendarUI";
import AdminPolicyHandbook from "../../../pages/employee/PolicyHandbook/AdminPolicyHandbook";
import ViewAllEmployeePaySlip from "../../../pages/employee/payslip/ViewAllEmployeePaySlip";
import MyAppreciation from "../../../pages/employee/certificates/MyAppreciation";
import AdminAssetManagent from "../../../pages/employee/assetManagement/AdminAssetManagent";

import MyPaySlips from "../../../pages/employee/payslip/PaySlip";
import EditEmployeeUser from "../../../pages/users/EditEmployeeUser";
import AddEmployeeUser from "../../../pages/users/AddEmployeeUser";
import AdminAttendanceView from "../../../pages/employee/attendance/AdminAttendanceView";
import LOPDetails from "../../../pages/employee/leaveBalance/LOPDetails";
import LeaveBalanceUpdate from "../../../pages/employee/leaveBalance/LeaveBalanceUpdate";
import AdminUserDetails from "../../../pages/employee/UserDetails/AdminUserDetails";
import AdminTaxDocument from "../../../pages/employee/TaxDocument/AdminTaxDocument";
import PolicyHandBook from "../../../pages/employee/PolicyHandbook/PolicyHandBook";
import ApprovalPermission from "../../../pages/employee/attendance/ApprovalPermission";
import AdminViewPermission from "../../../pages/employee/attendance/AdminViewPermission";
import ApproveLeaveList from "../../../pages/employee/attendance/leave/ApproveLeaveList";
import DeclineLeaveList from "../../../pages/employee/attendance/leave/DeclineLeaveList";
import YetToApproveLeaveList from "../../../pages/employee/attendance/leave/YetToApproveLeaveList";
import YetToActionPermissionList from "../../../pages/employee/attendance/permission/YetToActionPermissionList";
import ApprovalPermissionList from "../../../pages/employee/attendance/permission/ApprovalPermissionList";
import DeclinePermissionList from "../../../pages/employee/attendance/permission/DeclinePermissionList";
import EmployeeOpinionReply from "../../../pages/employee/opinions/reply/EmployeeOpinionReply";
import YetToReplyOpinions from "../../../pages/employee/opinions/reply/YetToReplyOpinions";
import RepliedOpinions from "../../../pages/employee/opinions/reply/RepliedOpinions";
import AddATSEmployeeUser from "../../../pages/users/AddATSEmployeeUser";
import GeneratePayslip from "../../../pages/employee/payslip/payslipNavTabs/GeneratePayslip";
import InternalJobpostingCandidates from "../../../pages/employee/internalJobposting/InternalJobpostingCandidates";
import InternalJobposting from "../../../pages/employee/internalJobposting/InternalJobposting";
import InternalJobpostingReferralCandidates from "../../../pages/employee/internalJobposting/InternalJobpostingReferralCandidates";
import EmployeeNavTab from "../../../pages/employee/EmployeeNavTab";
import EmployeeDashboardTab from "../../../pages/employee/EmployeeDashboardTab";
import AdminUserInfo from "../../../pages/employee/UserDetails/AdminUserInfo";
import AdminLoanManagement from "../../../pages/employee/loanManagement/AdminLoanManagement";
import AdminLoansNavTab from "../../../pages/employee/loanManagement/AdminLoansNavTab";
import AddEmployeeSteps from "../../../pages/users/AddEmployeeSteps";
import ProfilePage from "../../../pages/profile/ProfilePage";
import HierarchyTree from "../../../pages/employee/companyTree/HierarchyTree";
import AdminPayrollNavTabs from "../../../pages/employee/payslip/payslipNavTabs/AdminPayrollNavTabs";
import JDRpositories from "../../../pages/JDRepositories/JDRepositories";
import UploadQuickPayslip from "../../../pages/employee/payslip/payslipNavTabs/UploadQuickPayslip";
import AdminLeaveBalanceNavTabs from "../../../pages/employee/leaveBalance/AdminLeaveBalanceNavTabs";
import GenerateLeaveBalance from "../../../pages/employee/leaveBalance/GenerateLeaveBalance";
import UploadQuickLeaveBalance from "../../../pages/employee/leaveBalance/UploadQuickLeaveBalance";
import DuplicateCheckCandidates from "../../../pages/admin/DuplicateCheckCandidates";
import CheckedCandidateList from "../../../pages/admin/CheckedCandidateList";
import VendorSharedCandidates from "../../../pages/admin/VendorSharedCandidates";

const AdminRoutes = ({ role }) => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const companyType = decoded.companyType || "";
  return (
    <Switch>
      <AuthRoute
        path="/app/assign_requirements"
        role={role}
        roles={["ADMIN"]}
        component={AssignRequirements}
      />
      <AuthRoute
        path="/app/assign_freelancers"
        role={role}
        roles={["ADMIN"]}
        component={AssignFreelancers}
      />

      <AuthRoute
        path="/app/assign_vendors"
        role={role}
        roles={["ADMIN"]}
        component={AssignVendors}
      />
      <Route path="/app/freelancer">
        <AuthRoute
          path=""
          role={role}
          roles={["ADMIN"]}
          component={FreeLancers}
        />
        <AuthRoute
          path="/app/freelancer/requirements"
          role={role}
          roles={["ADMIN"]}
          component={FreelancerInfo}
        />
        <AuthRoute
          path="/app/freelancer/reports"
          role={role}
          roles={["ADMIN"]}
          component={FreelancerReport}
        />
      </Route>
      <Route path="/app/vendor">
        <AuthRoute path="" role={role} roles={["ADMIN"]} component={Vendors} />
        <AuthRoute
          path="/app/vendor/requirements"
          role={role}
          roles={["ADMIN"]}
          component={VendorInfo}
        />
        <AuthRoute
          path="/app/vendor/reports"
          role={role}
          roles={["ADMIN"]}
          component={VendorReport}
        />
      </Route>

      <AuthRoute
        path="/app/assigned_candidates"
        role={role}
        roles={["ADMIN"]}
        component={AssignedCandidates}
      />
      <AuthRoute
        path="/app/requirements_Candidate"
        role={role}
        roles={["ADMIN"]}
        component={Share}
      />
      <AuthRoute
        path="/app/reports/all_candidates_stc"
        role={role}
        roles={["ADMIN"]}
        component={AllSTC}
      />
      <AuthRoute
        path="/app/reports/all_candidates_schedule_interview"
        role={role}
        roles={["ADMIN"]}
        component={AllScheduleInterview}
      />
      <AuthRoute
        path="/app/reports/all_candidates_fic"
        role={role}
        roles={["ADMIN"]}
        component={AllFinalInterviewCompleted}
      />
      <AuthRoute
        path="/app/reports/all_candidates_document_collected"
        role={role}
        roles={["ADMIN"]}
        component={AllDocumentColleted}
      />
      <AuthRoute
        path="/app/reports/all_candidates_salary_breakup_shared"
        role={role}
        roles={["ADMIN"]}
        component={AllSalaryBreakup}
      />
      <AuthRoute
        path="/app/reports/all_candidates_offered"
        role={role}
        roles={["ADMIN"]}
        component={AllOffered}
      />
      <AuthRoute
        path="/app/reports/all_candidates_joined"
        role={role}
        roles={["ADMIN"]}
        component={AllJoined}
      />
      <AuthRoute
        path="/app/reports/all_candidates_ditched"
        role={role}
        roles={["ADMIN"]}
        component={AllDitched}
      />
      <AuthRoute
        path="/app/reports/all_candidates_credit_note"
        role={role}
        roles={["ADMIN"]}
        component={AllCreditNotes}
      />
      <AuthRoute
        path="/app/reports/all_candidates_Offered_declined"
        role={role}
        roles={["ADMIN"]}
        component={AllOfferedDeclined}
      />
      <AuthRoute
        path="/app/reports/all_candidates_drop"
        role={role}
        roles={["ADMIN"]}
        component={AllDrop}
      />

      <AuthRoute
        path="/app/users"
        role={role}
        roles={["ADMIN"]}
        component={Users}
      />
      {/* <AuthRoute path="/app/invoice" role={role} roles={["ADMIN"]} component={Invoice} />  */}
      <AuthRoute
        path="/app/chat"
        role={role}
        roles={["ADMIN"]}
        component={Chat}
      />

      <AuthRoute
        path="/app/activity"
        role={role}
        roles={["ADMIN"]}
        component={Activity}
      />
      <AuthRoute
        path="/app/settings/free_message_activity"
        role={role}
        roles={["ADMIN"]}
        component={FreeMessageActivity}
      />
      <AuthRoute
        path="/app/settings/admin_invoice_history"
        role={role}
        roles={["ADMIN"]}
        component={AdminInvoiceHistory}
      />
      <AuthRoute
        path="/app/settings/vendor_invoice_history"
        role={role}
        roles={["ADMIN"]}
        component={VendorInvoiceHistory}
      />
      <AuthRoute
        path="/app/candidate_activity"
        role={role}
        roles={["ADMIN"]}
        component={CandidateActivity}
      />
      <AuthRoute
        path="/app/admin_candidates"
        role={role}
        roles={["ADMIN"]}
        component={AdminCandidates}
      />
      <AuthRoute
        path="/app/check_duplicate_candidates"
        role={role}
        roles={["ADMIN"]}
        component={DuplicateCheckCandidates}
      />
      <AuthRoute
        path="/app/checking_candidates"
        role={role}
        roles={["ADMIN"]}
        component={CheckedCandidateList}
      />
      <AuthRoute
        path="/app/vendor_shared_candidates"
        role={role}
        roles={["ADMIN"]}
        component={VendorSharedCandidates}
      />
      <AuthRoute
        path="/app/plans"
        role={role}
        roles={["ADMIN"]}
        component={Plans}
      />
      <AuthRoute
        path="/app/admin_candidates_new"
        role={role}
        roles={["ADMIN"]}
        component={New}
      />
      <AuthRoute
        path="/app/admin_candidates_stc"
        role={role}
        roles={["ADMIN"]}
        component={STC}
      />
      <AuthRoute
        path="/app/admin_candidates_schedule_interview"
        role={role}
        roles={["ADMIN"]}
        component={ScheduleInterview}
      />
      <AuthRoute
        path="/app/admin_candidates_interview_scheduled"
        role={role}
        roles={["ADMIN"]}
        component={InterviewScheduled}
      />
      <AuthRoute
        path="/app/admin_candidates_final_interview_scheduled"
        role={role}
        roles={["ADMIN"]}
        component={FinalInterviewScheduled}
      />
      <AuthRoute
        path="/app/admin_candidates_fic"
        role={role}
        roles={["ADMIN"]}
        component={FinalInterviewCompleted}
      />
      <AuthRoute
        path="/app/admin_candidates_document_collected"
        role={role}
        roles={["ADMIN"]}
        component={DocumentColleted}
      />
      <AuthRoute
        path="/app/admin_candidates_salary_breakup_shared"
        role={role}
        roles={["ADMIN"]}
        component={SalaryBreakup}
      />
      <AuthRoute
        path="/app/admin_candidates_offered"
        role={role}
        roles={["ADMIN"]}
        component={Offered}
      />
      <AuthRoute
        path="/app/admin_candidates_joined"
        role={role}
        roles={["ADMIN"]}
        component={Joined}
      />
      <AuthRoute
        path="/app/admin_candidates_yet_to_join"
        role={role}
        roles={["ADMIN"]}
        component={YetToJoin}
      />

      <AuthRoute
        path="/app/dashboard"
        role={role}
        roles={[
          "SUPERADMIN",
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Dashboard}
      />
      <AuthRoute
        path="/app/search"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Search}
      />
      <AuthRoute
        path="/app/settings/source"
        role={role}
        roles={["ADMIN"]}
        component={Source}
      />
      <AuthRoute
        path="/app/settings/department-designation"
        role={role}
        roles={["ADMIN"]}
        component={Department}
      />
      <AuthRoute
        path="/app/settings/employee"
        role={role}
        roles={["ADMIN"]}
        component={Employers}
      />
      <AuthRoute
        path="/app/parsed_resume"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={ParsedResume}
      />
      <AuthRoute
        path="/app/requirements"
        role={role}
        roles={["ADMIN"]}
        component={Requirements}
      />
      <AuthRoute
        path="/app/jd-repositories"
        role={role}
        roles={["ADMIN", "CLIENTCOORDINATOR"]}
        component={JDRpositories}
      />
      <AuthRoute
        path="/app/singlechat"
        role={role}
        roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Singlechat}
      />

      <AuthRoute
        path="/app/transaction"
        role={role}
        roles={["SUPERADMIN", "ADMIN"]}
        component={Transaction}
      />
      <AuthRoute
        path="/app/ticket"
        role={role}
        roles={["SUPERADMIN", "ADMIN"]}
        component={Ticket}
      />
      <AuthRoute
        path="/app/profile"
        role={role}
        roles={["SUPERADMIN", "ADMIN"]}
        component={ProfilePage}
      />

      <AuthRoute
        path="/app/add-ats-employee"
        role={role}
        roles={["ADMIN"]}
        component={AddATSEmployeeUser}
      />
      {/* <AuthRoute path="/app/add-employee" role={role} roles={["ADMIN"]} component={AddEmployeeUser} /> */}
      <AuthRoute
        path="/app/add-employee"
        role={role}
        roles={["ADMIN"]}
        component={AddEmployeeSteps}
      />
      <AuthRoute
        path="/app/edit-employee"
        role={role}
        roles={["ADMIN"]}
        component={EditEmployeeUser}
      />
      <AuthRoute
        path="/app/view-employee"
        role={role}
        roles={["ADMIN"]}
        component={AdminUserDetails}
      />
      {/* <AuthRoute path="/app/view-userInfo" role={role} roles={["ADMIN"]} component={AdminUserInfo} /> */}

      <AuthRoute
        path="/app/employee/permissions-approval"
        role={role}
        roles={["ADMIN"]}
        component={ApprovalPermission}
      />

      <AuthRoute
        path="/app/employees"
        role={role}
        roles={["ADMIN"]}
        component={Employers}
      />
      <AuthRoute
        path="/app/employee/dashboard"
        role={role}
        roles={["ADMIN"]}
        component={EmployeeDashboardTab}
      />

      <Route path="/app/emp-info">
        <AuthRoute
          path=""
          role={role}
          roles={["ADMIN"]}
          component={AdminUserInfo}
        />
        <AuthRoute
          path="/app/emp-info/certificate"
          role={role}
          roles={["ADMIN"]}
          component={MyAppreciation}
        />
        <AuthRoute
          path="/app/emp-info/send-payslip"
          role={role}
          roles={["ADMIN"]}
          component={MyPaySlips}
        />
        <AuthRoute
          path="/app/emp-info/attendance-monitor"
          role={role}
          roles={["ADMIN"]}
          component={AdminAttendanceView}
        />
        <AuthRoute
          path="/app/emp-info/tax-documents"
          role={role}
          roles={["ADMIN"]}
          component={AdminTaxDocument}
        />
        <AuthRoute
          path="/app/emp-info/assets"
          role={role}
          roles={["ADMIN"]}
          component={AdminAssetManagent}
        />
        <AuthRoute
          path="/app/emp-info/loans"
          role={role}
          roles={["ADMIN"]}
          component={AdminLoansNavTab}
        />
      </Route>
      <Route path="/app/employee">
        <AuthRoute
          path=""
          role={role}
          roles={["ADMIN"]}
          component={EmployeeNavTab}
        />
        <AuthRoute
          path="/app/employee/projects"
          role={role}
          roles={["ADMIN"]}
          component={AddProjectDetails}
        />
        <AuthRoute
          path="/app/employee/leave-calendar"
          role={role}
          roles={["ADMIN"]}
          component={AdminCalendarUI}
        />
        <AuthRoute
          path="/app/employee/policy-handbook"
          role={role}
          roles={["ADMIN"]}
          component={AdminPolicyHandbook}
        />

        <AuthRoute
          path="/app/employee/view-payslip"
          role={role}
          roles={["ADMIN"]}
          component={ViewAllEmployeePaySlip}
        />
        {/* <AuthRoute path="/app/employee/permission" role={role} roles={["ADMIN"]} component={AdminViewPermission} /> */}
        <AuthRoute
          path="/app/employee/lop-details"
          role={role}
          roles={["ADMIN"]}
          component={LOPDetails}
        />
        <AuthRoute
          path="/app/employee/leave-balance-update"
          role={role}
          roles={["ADMIN"]}
          component={LeaveBalanceUpdate}
        />

        <AuthRoute
          path="/app/employee/internal-jobpostings"
          role={role}
          roles={["ADMIN"]}
          component={InternalJobposting}
        />
        <AuthRoute
          path="/app/employee/internal-jobposting-candidates"
          role={role}
          roles={["ADMIN"]}
          component={InternalJobpostingCandidates}
        />
        <AuthRoute
          path="/app/employee/internal-jobposting-referral-candidates"
          role={role}
          roles={["ADMIN"]}
          component={InternalJobpostingReferralCandidates}
        />
        {/* <AuthRoute path="/app/employee/certificate" role={role} roles={["ADMIN"]} component={MyAppreciation} /> */}
        <AuthRoute
          path="/app/employee/loan-details"
          role={role}
          roles={["ADMIN"]}
          component={AdminLoanManagement}
        />
        <AuthRoute
          path="/app/employee/company-tree"
          role={role}
          roles={["ADMIN"]}
          component={HierarchyTree}
        />

        <Route path="/app/employee/payroll">
          <AuthRoute
            path=""
            role={role}
            roles={["ADMIN"]}
            component={AdminPayrollNavTabs}
          />
          <AuthRoute
            path="/app/employee/payroll/generate-payslip"
            role={role}
            roles={["ADMIN"]}
            component={GeneratePayslip}
          />
          <AuthRoute
            path="/app/employee/payroll/upload-payslip"
            role={role}
            roles={["ADMIN"]}
            component={UploadQuickPayslip}
          />
        </Route>

        <Route path="/app/employee/leave-balance">
          <AuthRoute
            path=""
            role={role}
            roles={["ADMIN"]}
            component={AdminLeaveBalanceNavTabs}
          />
          <AuthRoute
            path="/app/employee/leave-balance/generate-leave-balance"
            role={role}
            roles={["ADMIN"]}
            component={GenerateLeaveBalance}
          />
          <AuthRoute
            path="/app/employee/leave-balance/upload-leave-balance"
            role={role}
            roles={["ADMIN"]}
            component={UploadQuickLeaveBalance}
          />
        </Route>

        <Route path="/app/employee/leave">
          <AuthRoute
            path=""
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={EmployeeLeave}
          />
          <AuthRoute
            path="/app/employee/leave/yet-to-approve"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={YetToApproveLeaveList}
          />
          <AuthRoute
            path="/app/employee/leave/approve"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={ApproveLeaveList}
          />
          <AuthRoute
            path="/app/employee/leave/decline"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={DeclineLeaveList}
          />
        </Route>

        <Route path="/app/employee/permission">
          <AuthRoute
            path=""
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={EmployeePermission}
          />
          <AuthRoute
            path="/app/employee/permission/yet-to-approve"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={YetToActionPermissionList}
          />
          <AuthRoute
            path="/app/employee/permission/approve"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={ApprovalPermissionList}
          />
          <AuthRoute
            path="/app/employee/permission/decline"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={DeclinePermissionList}
          />
        </Route>

        <Route path="/app/employee/opinions">
          <AuthRoute
            path=""
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={EmployeeOpinionReply}
          />
          <AuthRoute
            path="/app/employee/opinions/yet-to-reply"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={YetToReplyOpinions}
          />
          <AuthRoute
            path="/app/employee/opinions/replied"
            role={role}
            roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
            component={RepliedOpinions}
          />
        </Route>
      </Route>

      {companyType === "COMPANY" ? (
        <>
          <AuthRoute
            path="/app/projects"
            role={role}
            roles={["ADMIN"]}
            component={Projects}
          />
          <AuthRoute
            path="/app/reports/freelancer_onboarded_candidates"
            role={role}
            roles={["ADMIN"]}
            component={AllInvoiced}
          />
        </>
      ) : (
        <>
          <AuthRoute
            path="/app/clients"
            role={role}
            roles={["ADMIN"]}
            component={Clients}
          />
          <AuthRoute
            path="/app/resume_search"
            role={role}
            roles={["ADMIN"]}
            component={ResumeSearch}
          />
          <AuthRoute
            path="/app/reports/all_candidates_invoiced"
            role={role}
            roles={["ADMIN"]}
            component={AllInvoiced}
          />
        </>
      )}

      <AuthRoute path="*" component={PageNotFound} />
      {/* Add more routes specific to ADMIN here */}
    </Switch>
  );
};

export default AdminRoutes;
